import SkeletonBlock from '@loaders/SkeletonBlock';
import { memo } from 'react';

const BusinessSearchResultsSkeleton = memo(({ count = 4 }) => (
  <div
    className="flex w-full flex-col gap-business-results"
    aria-busy="true"
    aria-label="Loading results"
  >
    <SkeletonBlock className="skeleton-line h-4 w-28" />
    {Array.from({ length: count }, (_, index) => (
      <div key={index} className="flex w-full flex-col gap-1.5 desktop:gap-2 py-1.5 desktop:py-2">
        <SkeletonBlock className="skeleton-line h-6 w-52 max-w-full" />
        <SkeletonBlock className="skeleton-line h-5 w-72 max-w-full" />
        {index < count - 1 ? (
          <div className="mt-1 h-px w-full bg-merchant-border-strong" aria-hidden="true" />
        ) : null}
      </div>
    ))}
  </div>
));

BusinessSearchResultsSkeleton.displayName = 'BusinessSearchResultsSkeleton';

export default BusinessSearchResultsSkeleton;
